<template>
  <div>
    A opção <b>HORÁRIO LIMITE</b> refere-se as empresas que batem ponto após a meia noite.
  </div>
</template>

<script>
export default {
  name: "notification-template"
};
</script>
